import type { QueryClient } from "@tanstack/react-query";
import type { PaginatedResultOfGetAppointmentResponse } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { prefetchAppointmentBookingsCheck } from "./prefetchAppointmentBookingsCheck";
import { prefetchAppointmentsGet } from "./prefetchAppointmentsGet";
import { MEMBER_DASHBOARD_APPOINTMENT_SCROLL_QUERY } from "./memberDashboardPrefetch";

const MEMBER_APPOINTMENTS_PAGE = 1;
const MEMBER_APPOINTMENTS_PAGE_SIZE = 100;

export async function prefetchMemberPortalAppointmentsBundle(
  queryClient: QueryClient,
  accessToken: string,
) {
  await prefetchAppointmentsGet(
    queryClient,
    MEMBER_DASHBOARD_APPOINTMENT_SCROLL_QUERY,
    MEMBER_APPOINTMENTS_PAGE,
    MEMBER_APPOINTMENTS_PAGE_SIZE,
    undefined,
    undefined,
    accessToken,
  );

  const appointmentsData = queryClient.getQueryData<
    PaginatedResultOfGetAppointmentResponse
  >([
    QueryKeys.Appointments,
    MEMBER_DASHBOARD_APPOINTMENT_SCROLL_QUERY,
    MEMBER_APPOINTMENTS_PAGE,
    MEMBER_APPOINTMENTS_PAGE_SIZE,
    undefined,
    undefined,
  ]);

  const onlineAppointmentIds =
    appointmentsData?.items
      ?.filter((apt) => apt.allowOnlineBooking)
      .map((apt) => Number(apt.appointmentId))
      .filter((id) => id > 0) ?? [];

  if (onlineAppointmentIds.length > 0) {
    await prefetchAppointmentBookingsCheck(
      onlineAppointmentIds,
      queryClient,
      accessToken,
    );
  }

  return queryClient;
}
